<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <g fill="none" fill-rule="evenodd">
        <circle cx="8" cy="8" r="8" fill="currentColor" transform="translate(0 .5)"/>
        <g transform="translate(6 3.5)">
            <circle cx="2" cy="9" r="1.5" fill="#FFF"/>
            <path stroke="#FFF" stroke-linecap="round" stroke-width="2" d="M2 .5v5"/>
        </g>
    </g>
</svg>
